export default __webpack_public_path__ + "static/media/business.80e35880.jpg";